import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const bondSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Bond),
    isin: z.string().length(12, 'Must be exactly 12 characters long.'),
    currency_id: z.number().int(),
    country_id: z.number().int(),
    counterparty_id: z.number().int(),
    issuer: z.string(),
    maturity_date: z.iso.date(),
    description: z.string().min(1),
    top_level_bucket_id: z.number().nullable(),
});
